import { ArrowUpRight, ArrowRight, TrendingUp } from "lucide-react";

/**
 * Premium coded "ad-to-revenue" dashboard: dark glass panel showing ROAS, ad spend
 * tracked through to booked revenue, and channel split. Hero visual for the Scale
 * System page; sample demo view showing how tracking works.
 */
const channels = [
  { name: "Google Ads", value: 28400, pct: 100, color: "from-[#2F5FE8] to-[#4B7FFF]" },
  { name: "Meta Ads", value: 19800, pct: 70, color: "from-[#4B7FFF] to-[#2F5FE8]" },
];

export const ScaleRoasMockup = () => {
  return (
    <div className="relative w-full max-w-[400px] mx-auto select-none">
      {/* glow */}
      <div className="absolute -inset-8 -z-10 bg-[radial-gradient(circle_at_70%_25%,rgba(47,95,232,0.22),transparent_60%),radial-gradient(circle_at_25%_85%,rgba(47,95,232,0.14),transparent_60%)] blur-2xl" />

      <div className="relative overflow-hidden rounded-[1.75rem] border border-white/10 bg-white/[0.07] p-5 shadow-2xl shadow-black/40 backdrop-blur-xl">
        {/* header */}
        <div className="flex items-center justify-between">
          <div>
            <span className="text-xs font-semibold uppercase tracking-wide text-[#7EA0F5]">Ad performance</span>
            <div className="text-[10px] text-white/50 mt-0.5">sample view</div>
          </div>
          <span className="inline-flex items-center gap-2 text-xs font-mono-ibm font-bold text-slate-400 bg-slate-700/50 px-2.5 py-1 rounded-full">
            Demo
          </span>
        </div>

        {/* ROAS metric */}
        <div className="mt-2 flex items-end justify-between">
          <div>
            <div className="flex items-baseline gap-1.5">
              <span className="text-4xl font-bold tracking-tight text-white">5.2x</span>
              <span className="flex items-center gap-0.5 text-xs font-bold text-emerald-400">
                <ArrowUpRight className="h-3.5 w-3.5" /> ROAS
              </span>
            </div>
            <div className="mt-0.5 text-xs text-white/50">Return on ad spend</div>
          </div>
          <TrendingUp className="h-8 w-8 text-[#2F5FE8]/40" />
        </div>

        {/* spend -> revenue */}
        <div className="mt-4 flex items-center gap-3 rounded-2xl border border-white/10 bg-black/20 p-3">
          <div className="flex-1">
            <div className="text-[10px] uppercase tracking-wide text-white/70">Ad spend</div>
            <div className="text-sm font-bold text-white">$9,300</div>
          </div>
          <ArrowRight className="h-4 w-4 shrink-0 text-[#2F5FE8]" />
          <div className="flex-1 text-right">
            <div className="text-[10px] uppercase tracking-wide text-white/70">Booked revenue</div>
            <div className="text-sm font-bold text-white">$48,200</div>
          </div>
        </div>

        {/* channels */}
        <div className="mt-4 space-y-3">
          {channels.map((c) => (
            <div key={c.name}>
              <div className="mb-1 flex items-center justify-between text-xs">
                <span className="font-medium text-white/70">{c.name}</span>
                <span className="font-bold text-white">${(c.value / 1000).toFixed(1)}k</span>
              </div>
              <div className="h-2 overflow-hidden rounded-full bg-white/10">
                <div className={`h-full rounded-full bg-gradient-to-r ${c.color}`} style={{ width: `${c.pct}%` }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ScaleRoasMockup;
